import UtilsFormule from "../../../utils/UtilsFormule";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CarteCadeauService from "../../../services/MarketingService/CarteCadeauService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import toastr from "toastr";
const DataTableListCarteCadeau = ({ listCarteCadeaux }) => {
  const navigate = useNavigate();
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openDisable, setOpenDisable] = useState(false);
  const [carteCadeauId, setCarteCadeauId] = useState(false);
  const [status, setStatus] = useState(false);



  const handleOpenDelete = (row) => {
    setOpenDelete(true);
    setCarteCadeauId(row.id)
  }
  const handleCloseDelete = () => setOpenDelete(false);
  const handleOpenDisable = (row) => {
    setOpenDisable(true)
    setCarteCadeauId(row.id)
    setStatus(row.isActive == 1 ? 0 : 1)
    // console.log(row.isActive)
  };

  const handleCloseDisable = () => setOpenDisable(false);
  const { SearchBar } = Search;
  const handleClickDisable = async () => {
    try {
      const response = await CarteCadeauService.activeOrDesactiveCarteCadeau(getCurrentUserId(), carteCadeauId, status);
      toastr.success(response.data.success);
      handleCloseDisable()
      window.location.reload(true);
      // console.log("Carte Cadeau disabled successfully");
    } catch (error) {
      console.error("Error disabling Carte Cadeau:", error);
    }
  };
  const handleClickDelete = async () => {
    try {
      const response = await CarteCadeauService.activeOrDesactiveCarteCadeau(getCurrentUserId(), carteCadeauId, 1);
      toastr.success("Carte Cadeau deleted successfully");
      handleCloseDelete()
      window.location.reload(true);
      // console.log("Carte Cadeau disabled successfully");
    } catch (error) {
      console.error("Error disabling Carte Cadeau:", error);
    }
  };

  const actionFormatter = (cell, row) => {
    return (
      <div className="action-buttons">
        <button
          className="btn btn-dark mx-1"
          onClick={() => {
            console.log("Détails", row)
            sessionStorage.setItem("idCartesCadeau", row.id)
            navigate("/CartesCadeauDetails")

          }}
        >
          <h6>
            <small>
              {" "}
              <i class="fas fa-eye"></i>
            </small>
          </h6>
        </button>
        <button
          className="btn btn-secondary  mx-1"
          onClick={() => handleOpenDisable(row)}
        >
          <h6>
            <small>
              {" "}
              <i class="fas fa-ban"></i>
            </small>
          </h6>
        </button>
        <button
          className="btn btn-danger mx-1"
          onClick={() => handleOpenDelete(row)}
        >
          <h6>
            <small>
              {" "}
              <i class="fas fa-trash"></i>
            </small>
          </h6>
        </button>
      </div>
    );
  };
  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  function libelleFormatter(cell, row) {
    console.log("row", row);
    return (
      <span>
        {row.ref}-{row.name}
      </span>
    );
  }
  function productFormatter(cell, row) {
    if (row.product != null) {
      return (
        <span>
          {row.product.barcode}-{row.product.name}
        </span>
      );
    } else {
      return <span>Pas de produit</span>;
    }
  }

  function dateCreation(cell, row) {
    return <span>{UtilsFormule.formatDate(row.creationDate)}</span>;
  }

  function dateDebut(cell, row) {
    return <span>{UtilsFormule.formatDate(row.dateDebut)}</span>;
  }

  function dateFin(cell, row) {
    return <span>{UtilsFormule.formatDate(row.dateFin)}</span>;
  }

  const columns = [
    {
      dataField: "id",
      text: "Libellé",
      formatter: libelleFormatter,
      headerStyle: () => {
        return { width: "20%" };
      },
    },

    {
      dataField: "id",
      text: "Produit",
      align: "center",
      headerAlign: "center",
      formatter: productFormatter,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "creationDate",
      text: "DC",
      align: "center",
      headerAlign: "center",
      formatter: dateCreation,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "dateDebut",
      text: "Date Début",
      align: "center",
      headerAlign: "center",
      formatter: dateDebut,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "dateFin",
      text: "Date Fin",
      align: "center",
      headerAlign: "center",
      formatter: dateFin,
      headerStyle: () => {
        return { width: "15%" };
      },
    },

    {
      dataField: "value",
      text: "Prix",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    ,
    {
      dataField: "actions",
      text: "Actions", align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "17%" };
      },
      formatter: actionFormatter
    }
  ];

  return (
    <section class="content">
      <div class="card">
        <div class="card-header  ">
          <h3 class="card-title">Les Cartes Cadeaux Actives</h3>
          <div class="card-tools">
            <button
              type="button"
              class="btn btn-tool"
              data-card-widget="collapse"
              title="Collapse"
            >
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <div class="card-body ">
          <ToolkitProvider
            keyField="id"
            data={listCarteCadeaux}
            columns={columns}
            onTableChange={handleTableChange}
            exportCSV
            search
          >
            {(props) => (
              <div>
                <div className="row ml-0">
                  <div>
                    <SearchBar
                      {...props.searchProps}
                      className="custome-search-field"
                      style={{ color: "black" }}
                      placeholder="Chercher"
                    ></SearchBar>
                  </div>
                  <div className="ml-auto mr-0">
                    <MyExportCSV {...props.csvProps}></MyExportCSV>
                  </div>
                </div>
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                />
              </div>
            )}
          </ToolkitProvider>
          <Dialog open={openDelete} onClose={handleCloseDelete}>
            <DialogTitle>Confirmation</DialogTitle>
            <DialogContent>
              <DialogContentText>Voulez-vous vraiment supprimer cette carte cadeau ?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDelete} color="primary">Annuler</Button>
              <Button onClick={() => handleClickDelete()} color="error">Supprimer</Button>
            </DialogActions>
          </Dialog>

          <Dialog open={openDisable} onClose={handleCloseDisable}>
            <DialogTitle>Confirmation</DialogTitle>
            <DialogContent>
              <DialogContentText>Voulez-vous activer ou désactiver cette carte cadeau ?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDisable} color="primary">Annuler</Button>
              <Button onClick={handleClickDisable} color="error">Confirmer</Button>
            </DialogActions>
          </Dialog>

          {openInfoAlert && (
            <Snackbar
              open={openInfoAlert}
              autoHideDuration={2000}
              onClose={handleInfoClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
              <Alert variant="filled" onClose={handleInfoClose} severity="info">
                {infoAlertText}
              </Alert>
            </Snackbar>
          )}
        </div>
      </div>
    </section>
  );
};
export default DataTableListCarteCadeau;
